import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";

const DeleteRating = () => {
  return (
    <div className="relative min-h-screen">
      {/* Navbar on top of hero */}
      <Navbar />

      {/* Hero Section */}
      <section className="h-screen flex items-center justify-center bg-gray-50">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-800 text-center">
          Delete Rating Page
        </h1>
      </section>
    </div>
  );
};

export default DeleteRating;
